'use strict';
import React, { PureComponent } from 'react';


class DatosCriterios extends PureComponent {
    constructor(props) {
        super(props);

        this.cambiarOpcionComboCriterios = this.cambiarOpcionComboCriterios.bind(this);
        this.elegirOpcionSelector = this.elegirOpcionSelector.bind(this);
    }

    cambiarOpcionComboCriterios(nombreCombo, valorCombo) {
        this.props.cambiarOpcionComboCriterios(nombreCombo, valorCombo);
    }
    
    elegirOpcionSelector(seccionInput, nombreSelector, selectorElegido, agregarSelectorElegido){
        this.props.elegirOpcionSelector(seccionInput, nombreSelector, selectorElegido, agregarSelectorElegido)
    }

    render() {
        //ACTIONS
        const {
            setMostrarLinkVerMas
        } = this.props;

        //DATA
        const {
            arrayCombosCriteriosContables,
            arraySelectoresCriteriosContables,
            errorValidacion
        } = this.props;


        return (      
            <div>
                {arraySelectoresCriteriosContables.length > 0 &&
                    arrayCombosCriteriosContables.map( e => (
                        <div className="ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorCuentaContable_selectores_y_combosDinamicos">
                            <div className="seccionDatosGenerales__tituloSecundario">{e.descripcion}</div>

                            <div className="ABMModelosModalContainer__contenedorSelect">
                                <select 
                                    className="seccionDatosGenerales__inputSelect seccionDatosGenerales__sucursalSelect ABMModelos__seccionDatosGenerales__sucursalSelect"
                                    
                                    name={e.nombreCombo}
                                    onChange={(event) => {
                                        const indice = event.target.selectedIndex;
                                        const opcion = event.target.options[indice].value;
                                        this.cambiarOpcionComboCriterios(e.nombreCombo, opcion)
                                    }}
                                    value={e.valorSeleccionado}>
                                    {e.valoresCriterios}
                                </select>
                            </div>

                            <div>
                                {e.valorSeleccionado == "0" && errorValidacion.modalAltaEdicionRenglonContable.combosCriteriosContables &&
                                    <div>
                                        <label className="error">{errorValidacion.modalAltaEdicionRenglonContable.combosCriteriosContables}</label>
                                    </div>
                                }
                            </div>
                        </div>
                    ))
                }

                {arraySelectoresCriteriosContables.length > 0 &&                
                    arraySelectoresCriteriosContables.map( e => (
                        <div>
                            <div className="ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorCuentaContable_selectores_y_combosDinamicos">
                                <div className="seccionDatosGenerales__tituloSecundario">{e.descripcion}</div>

                                <div className="ABMModelosModalContainer__contenedorSelect">
                                    <select className="seccionDatosGenerales__inputSelect seccionDatosGenerales__sucursalSelect"
                                        name={e.nombreCombo}
                                        disabled={e.valoresCriterios.length == 1 && e.valorSeleccionadoCombo == "999"}
                                        onChange={(event) => {
                                        const indice = event.target.selectedIndex;
                                        const opcion = event.target.options[indice].value;
                                        this.elegirOpcionSelector("modalAltaEdicionRenglonContable", e.nombreCombo, opcion, true)
                                    }}
                                    value={e.valorSeleccionadoCombo}>
                                    <option value="-1" hidden={true} disabled={true}>Seleccione...</option>
                                    {e.valoresCriterios}
                                    </select>
                                </div>
                            </div>
                            <div>
                            </div>
                            <div className='ABMModelos__scrollModelosSeleccionadosEtiquetas'>
                                {(e.valoresCriterios.length == 1 && e.valorSeleccionadoCombo == "999") ?
                                    <div className="btn-group ABMModelosModalContainer__botonModelo">
                                        <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-left not-clickable ABMModelosModalContainer__modalAltaEdicionRenglonContable__botonModeloDescripcion">Todos</button>
                                        <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-right ABMModelosModalContainer__modalAltaEdicionRenglonContable__botonCierre" onClick = {() => this.elegirOpcionSelector("modalAltaEdicionRenglonContable", e.nombreCombo, 999, false)}>
                                            <span className="ti-close span-closable color-white" title="Quitar Modelo"></span>
                                        </button>
                                    </div> 
                                :
                                    e.valoresSeleccionados.slice(0, e.mostrarLinkVerMas ? 9 : e.valoresSeleccionados.length).map((se,index) =>                                 
                                        <div key={se.id + se.descripcion} className="btn-group ABMModelosModalContainer__botonModelo">
                                            <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-left not-clickable ABMModelosReemplazar__botonModeloDescripcion">
                                                {se.descripcion.length > 16 ? se.descripcion.substr(0, 15) + String.fromCharCode(8230) : se.descripcion}
                                            </button>
                                            <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-right" onClick = {() => this.elegirOpcionSelector("modalAltaEdicionRenglonContable", e.nombreCombo, se.id, false)}>
                                                <span className="ti-close span-closable color-white" title="Quitar Modelo"></span>
                                            </button>
                                            {index == 8 && e.mostrarLinkVerMas? <div key={"verMas"} className="ABMModelosModalContainer__modalAltaEdicionRenglonContable__linkVerMas"><span onClick={() => setMostrarLinkVerMas("modalAltaEdicionRenglonContable",e.nombreCombo, !e.mostrarLinkVerMas)}>Ver más...</span></div> : null}
                                        </div>)
                                }
                            </div>
                            <div>
                                {e.valoresSeleccionados.length == 0 && errorValidacion.modalAltaEdicionRenglonContable.combosCriteriosContables &&
                                    <div>
                                        <label className="error">{errorValidacion.modalAltaEdicionRenglonContable.combosCriteriosContables}</label>
                                    </div>
                                }
                            </div>
                        </div>
                    )
                )}
            </div>
        );
    }
}

export default DatosCriterios;